module.exports = "https://coursera_assets.s3.amazonaws.com/images/73feba6a844effd3a1116ba46b805171.png";